"use client";

import React, { useState } from "react";
import { Card, Table, Badge } from "react-bootstrap";
import { useNotifications } from "../../hooks/useNotifications";
import NotificationModal from "../User/NotificationModal";

const NotificationsTable = () => {
  const { data, markAsRead } = useNotifications();
  const [selected, setSelected] = useState(null);

  const openNotification = (item) => {
    setSelected(item);
    if (item.status === "UNREAD") {
      markAsRead(item.id);
    }
  };

  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-4">
          <Table hover responsive>
            <thead>
              <tr>
                <th>عنوان</th>
                <th>تاریخ</th>
                <th>وضعیت</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr
                  key={item.id}
                  style={{ cursor: "pointer" }}
                  onClick={() => openNotification(item)}
                >
                  <td className="fw-medium">{item.title}</td>
                  <td>{new Date(item.createdAt).toLocaleString("fa-IR")}</td>
                  <td>
                    <Badge bg={item.status === "UNREAD" ? "warning" : "success"}>
                      {item.status === "UNREAD" ? "خوانده نشده" : "خوانده شده"}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <NotificationModal
        show={!!selected}
        notification={selected}
        onHide={() => setSelected(null)}
      />
    </>
  );
};

export default NotificationsTable;
